import layout from '@/layout';
import routerMap from '../routerMap.js';

const meta = { auth: true };
export default{
  path: '/system',
  name: 'system',
  meta:{...meta,title:"系统设置",hidden:true},
  component: layout,
  children: ((pre,prePath) => [
    { path: `${prePath}system/company`, name: `${pre}system-company`, component:routerMap.companyList, meta: { ...meta, title: '公司定义' }},
    { path: `${prePath}auth/resource`, name: `${pre}auth-resource`, component:routerMap.resourceList, meta: { ...meta, title: '资源管理' }},
    { path: `${prePath}auth/role`, name: `${pre}auth-role`, component:routerMap.roleList, meta: { ...meta, title: '角色管理' }},
    { path: `${prePath}/role/auth/:id`, name: `${pre}role-auth`, component:routerMap.roleAuth, meta: { ...meta, title: '角色权限' }},
    { path: `${prePath}auth/user`, name: `${pre}auth-user`, component:routerMap.userList, meta: { ...meta, title: '用户管理' }},
    { path: `${prePath}auth/user`, name: `${pre}auth-user`, component:routerMap.userList, meta: { ...meta, title: '用户管理' }},
    { path: `${prePath}monitor/log`, name: `${pre}monitor-log`, component:routerMap.monitorLog, meta: { ...meta, title: '操作日志' }}
  ])('system-','/system/')
}
